import { Fragment } from 'react'
import classNames from 'classnames'

import type { MenuType } from 'types'
import Link from 'content-components/_Primatives/Link'
import style from './style.scss'

type Props = {
  className?: string
  handleToggle?: () => void
  links: Array<MenuType> // supports firing an event after activation of a menu item.
  variant?: 'condensed'
}

function AccordionLinks(props: Props) {
  const { className, handleToggle, links, variant } = props

  return (
    <div
      className={classNames(
        style.wrapper,
        { [style.condensed]: variant === 'condensed' },
        className,
      )}
    >
      {links.map(({ text, url, below }, index) => (
        <Fragment key={`${text}${index}`}>
          <span onClick={handleToggle}>
            <Link key={text} className={style.link} url={url}>
              {text}
            </Link>
          </span>
          {below &&
            below.map((subLink: MenuType) => (
              <span key={subLink.text} onClick={handleToggle}>
                <Link
                  className={classNames(style.link, style.linkSubItem)}
                  url={subLink.url}
                >
                  {subLink.text}
                </Link>
              </span>
            ))}
        </Fragment>
      ))}
    </div>
  )
}

export default AccordionLinks
